import React, { useState, useEffect, useRef } from 'react'; 
import Select, { StylesConfig } from 'react-select'; 
import { useTranslation } from 'react-i18next';

const StatusDropdown = ({ statuses, defaultStatus , onChangeStatus, isDisabled, onCloseEditStatus}) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;     

  const [selectedOption, setSelectedOption] = useState(0);

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption.value);
    onChangeStatus(selectedOption.value);
    onCloseEditStatus();

    
  };


  const handleMenuClose = () => {
    onCloseEditStatus(); 
    };


  useEffect(() => {
    setSelectedOption(defaultStatus.id)
  }, [defaultStatus])


const statusLabels = {
  2: { ka: 'ნაყიდია',                en: 'Purchased',             ru: 'Куплено' },
  3: { ka: 'მიყვანილია საწყობში',    en: 'Delivered to warehouse',ru: 'Доставлено на склад' },
  4: { ka: 'ჩატვირთულია',             en: 'Loaded',                ru: 'Загружено' },
  5: { ka: 'დასრულებულია',           en: 'Completed',             ru: 'Завершено' },
  6: { ka: 'საბუთი გაცემულია',       en: 'Documents issued',      ru: 'Документы выданы' },
  7: { ka: 'შემოვიდა პორტში',       en: 'Arrived at port',       ru: 'Прибыло в порт' },
  1: { ka: 'ინვოისი გამოწერილია',    en: 'Invoice issued',        ru: 'Счёт выставлен' },
  8: { ka: 'თანხის უკან დაბრუნება',  en: 'Refunded',              ru: 'Возврат средств' },
  9: { ka: 'Ჩანაცვლდა',             en: 'Replaced',              ru: 'Замена' },
  10: { ka: 'რელისტი',             en: 'Relist',              ru: 'Релист' },
  11: { ka: 'არ რეალიზდა',             en: 'Not Realized',              ru: 'Не реализовано' },
};

const options = statuses.map(status => ({
  value: status.id,
  label: statusLabels[status.id]?.[lang] ?? status.name,
  color: status.color,
}));


  // const options = statuses.map((status) => ({ value: status.id, label: status.name ,  color: status.color}));

 


  const dot = (color = 'transparent') => ({
    alignItems: 'center',
    color: 'var(--text-color)', 
    display: 'flex', 
    ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 4,
      minHeight: 10,
      minWidth: 10,
    },
  });
  

  const colourStyles = {

    control: (provided, state) => ({
      ...provided,
       backgroundColor: 'white', 
       border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',  
       boxShadow: state.isFocused ? 'none' : 'none', 
       '&:hover': {
         border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',
       }, 
       minHeight: "unset", 
       width: '170px', 
       height: '22px',
       cursor: 'pointer',    
       borderRadius: '5px',  
    }),


    dropdownIndicator: (provided) => ({
      ...provided,
      //display: 'none', 
      color: 'var(--muted-text-color)',
      padding: '3px 3px 3px 0px',
      "svg": {
          width: '14px',
          height: '14px',
      }
      }),


    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
      }),
    
    indicatorsContainer: (provided) => ({
      ...provided,
    }),

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      let backgroundColor;
      let color;
      let cursor = isDisabled ? 'not-allowed' : 'pointer';
  
      if (isDisabled) {
        backgroundColor = undefined;
        color = '#ccc';
      } else if (isSelected) {
       // backgroundColor = data.color;
        backgroundColor = '#f1f1f1';
        color = undefined;
      } else if (isFocused) { 
        backgroundColor = '#f1f1f1';
        color = data.color;
      } else {
        backgroundColor = undefined;
        color = data.color;
      }
  
      let activeBackgroundColor;
      if (!isDisabled) {
        if (isSelected) {
          activeBackgroundColor = data.color;
        } else { 
          activeBackgroundColor = '#fff';
        }
      }
  
      return {
        ...styles,
        fontSize: '12px',
        padding: '5px 8px',
        alignItems: 'center',
        color: 'var(--text-color)', 
        display: 'flex', 
        ':before': { 
          backgroundColor: isSelected ? data.color : color, // This line is modified
          borderRadius: 10,
          content: '" "',
          display: 'block',
          marginRight: 8,
          height: 10,
          width: 10,
        },
    

       // backgroundColor: backgroundColor,
        backgroundColor: backgroundColor,
       // color: color,
        cursor: cursor,
        ':active': {
          ...styles[':active'],
          backgroundColor: backgroundColor,
        },
      };
    },
    input: (styles) => ({ 
      ...styles, 
      ...dot(), 
      fontSize: '12px'
    }),

    valueContainer: (styles) => ({
      ...styles,
      padding: "1px",  
    }),


    placeholder: (styles) => ({ ...styles, ...dot('#ccc') }), 
    singleValue: (styles, { data }) => ({ ...styles, fontSize: '12px', ...dot(data.color) }),
  };

   


  return (
    <>  


        
<Select   
             styles={colourStyles}
             isSearchable={false} 
             onChange={handleChange}
            onMenuClose={handleMenuClose}
             value={options.filter(function(option) {
               return option.value === selectedOption;
             })}
             options={options}
             isDisabled={isDisabled}
           />   

     
    </>
  );


};

export default StatusDropdown;